import Vue from "vue";
import Router from "vue-router";
import Index from "./views/index.vue";
import { cancelRequests } from "@/api/lib";
Vue.use(Router);

let router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      redirect: "/homePark",
      meta: {
        title: "首页",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/homePark",
      name: "homePark",
      component: (resolve) =>
        require(["@/views/homePark/homePark.vue"], resolve),
      meta: {
        title: "首页",
        keepAlive: true, //需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/allPark",
      name: "allPark",
      component: (resolve) => require(["@/views/allPark/allPark.vue"], resolve),
      meta: {
        title: "全部园区",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/parkManagement",
      name: "parkManagement",
      component: (resolve) =>
        require(["@/views/parkManagement/parkManagement.vue"], resolve),
      meta: {
        title: "园区管理",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/enterPark",
      name: "enterPark",
      component: (resolve) =>
        require(["@/views/enterPark/enterPark.vue"], resolve),
      meta: {
        title: "入驻园区",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
      redirect: "/enterPark/buildInfo",
      children: [
        {
          path: "buildInfo",
          name: "buildInfo",
          component: (resolve) =>
            require(["@/views/enterPark/pages/buildInfo.vue"], resolve),
          meta: {
            title: "园区信息",
            keepAlive: false, //此组件不需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          },
        },
      ],
    },
    {
      path: "/matchParkList",
      name: "matchParkList",
      component: (resolve) =>
        require(["@/views/matchParkList/matchParkList.vue"], resolve),
      meta: {
        title: "园区匹配结果",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/parkDetail",
      name: "parkDetail",
      component: (resolve) =>
        require(["@/views/parkDetail/parkDetail.vue"], resolve),
      meta: {
        title: "园区详情",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      path: "/parkMap",
      name: "parkMap",
      component: (resolve) => require(["@/views/parkMap/parkMap.vue"], resolve),
      meta: {
        title: "地图找园区",
        keepAlive: false, //此组件不需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name === "homePark") {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  cancelRequests(); // 终止进行中的请求
  next();
});
router.afterEach(() => {
  // 在每次路由跳转后执行滚动到顶部的操作
  window.scrollTo(0, 0);
})

export default router;
